import React from 'react';
import { IconS24Close24, IconS24InfoCircle24 } from '@is24/cosma-ui-icons';
import { Popover } from 'is24-corecss';
import './InfoPopOver.css';

interface InfoPopOverProps {
  content: string[] | string;
}

const InfoPopOver: React.FC<InfoPopOverProps> = ({ content }) => {
  const contentArray = Array.isArray(content) ? content : content ? [content] : [];

  return (
    <div className='grid margin-left-xs grid-align-center' style={{ position: 'relative' }}>
      <Popover.Root placement='top' withArrow>
        <Popover.Target as='button' className='verification-info-icon' data-testid='info-icon' aria-label='Information'>
          <IconS24InfoCircle24 height={18} width={18} color='#676767' />
        </Popover.Target>
        <Popover.Content
          className='custom-popover font-body-medium-regular padding-left-xxl tvs-pop-over-dark'
          renderCloseButton={({ closePopover, getCloseButtonProps }) => (
            <button
              {...getCloseButtonProps({ className: 'info-close-button', onClick: closePopover })}
              data-testid='close-icon'
            >
              <IconS24Close24 width={16} height={16} />
            </button>
          )}
        >
          <ul className='popover-list'>
            {contentArray.map((text, index) => (
              <li key={index} className='popover-item'>
                {text}
              </li>
            ))}
          </ul>
        </Popover.Content>
      </Popover.Root>
    </div>
  );
};

export default InfoPopOver;
